import React from "react";
import { styled, useTheme } from "@mui/system";
import useMediaQuery from "@mui/material/useMediaQuery";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip"; // Import Tooltip component
import AccountActions from "./AccountActions"; // Import the AccountActions component
import { CircularButton } from "./AccountActions"; // Import the CircularButton component
import ReactRouterLink from "./ReactRouterLink";

const StyledAppBar = styled(AppBar)({
  top: "auto",
  bottom: 0,
  backgroundColor: "#fff",
});

const StyledToolbar = styled(Toolbar)({
  justifyContent: "space-between", // Center and space components evenly
  padding: "0 20px", // Add some padding to the left and right
});

const MobileNavBar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  if (!isMobile) {
    return null;
  }

  return (
    <StyledAppBar position="fixed" color="default">
      <StyledToolbar>
        {/* Make the logo icon clickable and navigate to the homepage */}
        <Tooltip title="FiddlePiddle" arrow>
          <ReactRouterLink
            to="/"
            linkElement={
              <CircularButton>
                <img
                  src="/logoicon.png"
                  alt="LogoIcon"
                  style={{ width: "30px", height: "30px" }}
                />
              </CircularButton>
            }
          />
        </Tooltip>
        {/* Include the AccountActions component */}
        <AccountActions onLogin={() => {}} onSell={() => {}} />
      </StyledToolbar>
    </StyledAppBar>
  );
};

export default MobileNavBar;
